import { localize } from '../i18n';
import SingleLineText from './ui/SingleLineText';
import Button from './ui/FitButton';
import React, { useState, useLayoutEffect } from 'react';
import BottomSheet from './BottomSheet';
import AlertMethodSection from '../pages/medication-form/reminder/AlertMethodSection';

/**
 * 알림 방식 수정 시트 — 확인 페이지의 알림 카드에서 "방식" ✏ 클릭 시 노출.
 */
export default function EditAlertMethodSheet({ open, form, onClose, onSave }) {
    const [staging, setStaging] = useState(null);

    useLayoutEffect(() => {
        if (open) {
            setStaging({
                alertType: form.alertType,
                alarmVolume: form.alarmVolume,
            });
        }
    }, [open, form]);

    if (!staging) return <BottomSheet open={open} onClose={onClose}>{null}</BottomSheet>;

    const updateStaging = (updater) => {
        setStaging(prev => typeof updater === 'function' ? updater(prev) : updater);
    };

    const handleSave = () => {
        onSave({ alertType: staging.alertType, alarmVolume: staging.alarmVolume });
        onClose();
    };

    return (
        <BottomSheet open={open} onClose={onClose} footer={
            <>
                <Button
                    fullWidth
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={handleSave}
                    sx={{
                        bgcolor: '#ffe566', color: '#5a4a00',
                        borderRadius: 3, py: 1.6, fontSize: '1.1rem', fontWeight: 700,
                        boxShadow: '0 4px 12px rgba(230,168,0,0.3)',
                        '&:hover': { bgcolor: '#e8d040' },
                    }}
                >{localize("저장")}</Button>
            </>
        }>
            <SingleLineText sx={{ fontSize: '1.15rem', fontWeight: 800, color: '#1a1a1a', mb: 2 }}>{localize("알림 방식 수정")}</SingleLineText>
            <AlertMethodSection form={staging} setForm={updateStaging} />
        </BottomSheet>
    );
}
